import { useEffect, useState } from 'react'

import { SAPDowntimeModal } from '@/components/ConfigurationModal'
import { useAppSelector } from '@/store/hook'
import { selectIsCurrentTimeInSAPDowntime } from '@/store/slices/configSlice'

const SAPDownTime = () => {
  const isCurrentTimeInSAPDowntime = useAppSelector(
    selectIsCurrentTimeInSAPDowntime,
  )

  const [shouldOpenSAPDowntimeModal, setShouldOpenSAPDowntimeModal] = useState(false)

  const handleCloseModal = (): void => {
    setShouldOpenSAPDowntimeModal(false)
  }

  useEffect(() => {
    if (isCurrentTimeInSAPDowntime) {
      setShouldOpenSAPDowntimeModal(true)
    }
  }, [isCurrentTimeInSAPDowntime])

  return shouldOpenSAPDowntimeModal
    ? (
      <SAPDowntimeModal
        open={isCurrentTimeInSAPDowntime}
        onClose={handleCloseModal}
      />
    )
    : null
}

export default SAPDownTime
